import React, { useState, useEffect, useRef } from "react"
import { getSituazionePagamenti } from "../../services/endpoints";
import { showProgress } from "../../utils/elements";
import * as Constants from '../../utils/constants'
import {
  Container,
  Row,
  Col,
  Alert,
  Button,
  Popover,
  PopoverHeader,
  PopoverBody,
  Icon
} from 'design-react-kit';

export const SibaMostraSituazionePagamenti = ({ _veicolo, _handleSubmit, _handleBack }) => {

  const [situazionePagamenti, setSituazionePagamenti] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [popoverInsufficienteOpen, setPopoverInsufficienteOpen] = useState(false);
  const insufficienteRef = useRef(null);

  const [popoverNonAnnualeOpen, setPopoverNonAnnualeOpen] = useState(false);
  const nonAnnualeRef = useRef(null);

  const [popoverPagabileOpen, setPopoverPagabileOpen] = useState(false);
  const pagabileRef = useRef(null);

  const [popoverPagatoOpen, setPopoverPagatoOpen] = useState(false);
  const pagatoRef = useRef(null);

  const [isAlertNonPagabileOpen, setAlertNonPagabileOpen] = useState(false);
  const [causaleWarningNonPagabile, setCausaleNonPagabile] = useState('');

  const [isAlertNonAnnualeOpen, setAlertNonAnnualeOpen] = useState(false);
  const [causaleNonAnnuale, setCausaleNonAnnuale] = useState('');

  const [isAlertInsufficienteOpen, setAlertInsufficienteOpen] = useState(false);
  const [causaleInsufficiente, setCausaleInsufficiente] = useState('');

  const [isAlertPagatoOpen, setAlertPagatoOpen] = useState(false);
  const [causalePagato, setCausalePagato] = useState('');

  const [isAlertNonPagatoOpen, setAlertNonPagatoOpen] = useState(false);
  const [causaleNonPagato, setCausaleNonPagato] = useState('');


  useEffect(() => {
    loadInfoPagamento(_veicolo);
  }, [])

  const loadInfoPagamento = async (veicolo) => {
    var annoDiInizioRicerca = new Date().getFullYear() - Constants.ULTIMI_TRE_ANNI;
    const responseSituazionePagamenti = await getSituazionePagamenti(annoDiInizioRicerca, veicolo.idVeicolo, veicolo.idProprietario);
    if (responseSituazionePagamenti === undefined) {
      console.log('Pagamenti dal %s per veicolo %s non trovati', annoDiInizioRicerca, veicolo.idVeicolo)
      setSituazionePagamenti([])
      setLoading(false)
      return
    }
    //console.log(responseSituazionePagamenti);
    setSituazionePagamenti(responseSituazionePagamenti)
    setLoading(false)
    //console.log(situazionePagamenti)
  }

  const handleSubmit = (dati) => { _handleSubmit(dati) }

  const togglePopoverInsufficiente = () => {
    setPopoverInsufficienteOpen(!popoverInsufficienteOpen);
  };

  const togglePopoverNonAnnuale = () => {
    setPopoverNonAnnualeOpen(!popoverNonAnnualeOpen);
  };

  const togglePopoverPagabile = () => {
    setPopoverPagabileOpen(!popoverPagabileOpen);
  };

  const togglePopoverPagato = () => {
    setPopoverPagatoOpen(!popoverPagatoOpen);
  };

  const isNonAnnuale = (schedaPagamento) => {
    return schedaPagamento.risultato.toString() === Constants.MODO_PAGAMENTO_NON_ANNUALE;
  }

  const isInsufficiente = (schedaPagamento) => {
    return schedaPagamento.isPagabile && schedaPagamento.isCalcolabile && schedaPagamento.isInsufficiente;
  }

  const isPagabile = (schedaPagamento) => {
    return schedaPagamento.isPagabile && schedaPagamento.isCalcolabile;
  }

  const isStorico = (schedaPagamento) => {
    return schedaPagamento.risultato.includes("storico");
  }

  const isPagato = (schedaPagamento) => {
    return !schedaPagamento.isPagabile && schedaPagamento.isCalcolabile;
  }

  const isNonDovuto = (schedaPagamento) => {
    let noDovuto =  schedaPagamento.risultato.includes('uscita da Regione') || 
                      schedaPagamento.risultato.includes('CT00ESE00') ||
                      schedaPagamento.risultato.includes('non in carico alla Regione'); 
    return noDovuto && !schedaPagamento.isCalcolabile && !schedaPagamento.isPagabile;
  }

  const isNonAncoraPagabile = (schedaPagamento) => {
    let oggi = new Date();
    let isAnnoInCorso = String(schedaPagamento.anno) === String(oggi.getFullYear()) ? true : false;
    return  isAnnoInCorso && !schedaPagamento.isCalcolabile;
  }

  const toggleAlertNonPagabile = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + " non pagabile: ";
    if (schedaPagamento.risultato.includes("-")) {
      const isNonAncoraPagabile = schedaPagamento.risultato.split(" - ")[1].includes("Posizione annuale non corretta");
      message += isNonAncoraPagabile ? "Non ancora pagabile" : schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausaleNonPagabile(message)
    setAlertNonPagabileOpen(!isAlertNonPagabileOpen);
  }

  const toggleAlertNonAnnuale = (schedaPagamento) => {
    let message = "Periodicità " + schedaPagamento.anno + ": "; //TODO
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato.replace("_", " ");
    }
    setCausaleNonAnnuale(message)
    setAlertNonAnnualeOpen(!isAlertNonAnnualeOpen);
  }

  const toggleAlertInsufficiente = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + " da rettificare: ";
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausaleInsufficiente(message)
    setAlertInsufficienteOpen(!isAlertInsufficienteOpen);
  }

  const toggleAlertPagato = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + ": ";
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausalePagato(message)
    setAlertPagatoOpen(!isAlertPagatoOpen);
  }

  const toggleAlertNonPagato = (schedaPagamento) => {
    let message = "Anno " + schedaPagamento.anno + " da rettificare: ";
    if (schedaPagamento.risultato.includes("-")) {
      message += schedaPagamento.risultato.split(" - ")[1];
    } else {
      message += schedaPagamento.risultato;
    }
    setCausaleNonPagato(message)
    setAlertNonPagatoOpen(!isAlertNonPagatoOpen);
  }

  const buildPulsantePerRigaTabella = (schedaPagamento) => {
    if (isNonAnnuale(schedaPagamento)) {
      return (
        <div>
          <Button
            className="btn btn-primary"
            size="xs"
            color="primary"
            icon={false}
            tag="button"
            innerRef={nonAnnualeRef}
            onClick={() =>  handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.CONS_CHOICE_PAGAMENTO_DETTAGLI })}
          > Visualizza i pagamenti
          </Button>
        </div>
      )
    }

    if (isInsufficiente(schedaPagamento)) {
      return (
        <div>
          <Button
            className="btn btn-60 btn-success"
            size="xs"
            color="primary"
            icon={false}
            tag="button"
            onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.CONS_CHOICE_PAGAMENTO_DETTAGLI })}
            innerRef={insufficienteRef}
          > Visualizza
          </Button>
          {/*<Button
            className="btn btn-light ml-2"
            size="xs"
            icon={true}
            tag="button"
            onClick={() => toggleAlertInsufficiente(schedaPagamento)}
          > &nbsp;?&nbsp;
          </Button> */}
        </div>
      )
    }

    if(schedaPagamento.hasRuolo){
      return <div>EMESSA CARTELLA DI PAGAMENTO</div>
    }
    if (isPagabile(schedaPagamento)) {
      return (
        <div>
          <Button
            className="btn btn-60 btn-danger"
            size="xs"
            color="primary"
            icon={false}
            tag="button"
            innerRef={pagabileRef}
            onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.CONS_CHOICE_PAGAMENTO_CALCOLO })}
          > Paga
          </Button>
          {/*<Button
            className="btn btn-light ml-2"
            size="xs"
            icon={true}
            tag="button"
            onClick={() => toggleAlertNonPagato(schedaPagamento)}
          > &nbsp;?&nbsp;
          </Button>*/}
          <Popover
            placement='left'
            trigger='hover'
            target={pagabileRef}
            isOpen={popoverPagabileOpen}
            toggle={togglePopoverPagabile}
          >
            <PopoverBody>
              Questa funzione effettua il calcolo del dovuto (per pagare verr&agrave; richiesta successiva conferma)
            </PopoverBody>
          </Popover>
        </div>
      )
    }

    if (isStorico(schedaPagamento)) {
      return (
        <div>
          <Button
            className="btn btn-60 btn-dark"
            size="xs"
            color="primary"
            icon={false}
            tag="button"
            onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.CONS_CHOICE_PAGAMENTO_DETTAGLI })}
          > 
          Veicolo storico
          </Button>
        </div>
      )
    }

    if (isNonDovuto(schedaPagamento)) {
      return (
        <div>
          <span><strong>Non Dovuto</strong></span>
        </div>
      )
    }

    if(isNonAncoraPagabile(schedaPagamento)){
      return (
        <div>
          <span><strong>Non ancora pagabile</strong></span>
        </div>
      )
    }

    if (isPagato(schedaPagamento)) {
      return (
        <div>
          <Button
            className="btn btn-60 btn-success"
            size="xs"
            color="primary"
            icon={false}
            tag="button"
            innerRef={pagatoRef}
            onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.CONS_CHOICE_PAGAMENTO_DETTAGLI })}
          > Visualizza
          </Button>
          {/*<Button
            className="btn btn-light ml-2"
            size="xs"
            icon={true}
            tag="button"
            onClick={() => toggleAlertPagato(schedaPagamento)}
          > &nbsp;?&nbsp;
          </Button>*/}
          <Popover
            placement='left'
            trigger='hover'
            target={pagatoRef}
            isOpen={popoverPagatoOpen}
            toggle={togglePopoverPagato}
          >
            <PopoverBody>
              Visualizzazione dei dettagli sui pagamenti effettuati
            </PopoverBody>
          </Popover>
        </div>
      )
    }

    return (<>{"-"}</>);
  }

  const isOwned = (schedaPagamento) => {
    return (
      //starest: "AUTO NON ANCORA DI PROPRIETA"
      !schedaPagamento.risultato.includes("NON ANCORA")
      //stacobon: "Non trovato ingresso in Regione in tempo utile"
      && !schedaPagamento.risultato.includes("Non trovato")
      //stacobon: "Trovata uscita da Regione in tempo utile"
      && !schedaPagamento.risultato.includes("Trovata uscita")
    )
  }

  const buildTableRow = (schedaPagamento) => {
    if (!isOwned(schedaPagamento)) {
      return (React.Fragment)
    }

    return (
      <tr key={schedaPagamento.anno}>
        <td className="align-middle text-center">{schedaPagamento.anno}</td>
        <td className="align-middle text-center">{schedaPagamento.targa}</td>
        {/* <td class="align-middle text-center">{schedaPagamento.scadenza}</td> */}
        <td className="align-middle text-center">{buildPulsantePerRigaTabella(schedaPagamento)}</td>
      </tr>
    )
  }

  const showAlertNonAnnuale = () => { return isAlertNonAnnualeOpen ? <Alert color="warning" > {causaleNonAnnuale} </Alert> : React.Fragment; }
  const showAlertInsufficiente = () => { return isAlertInsufficienteOpen ? <Alert color="warning" > {causaleInsufficiente} </Alert> : React.Fragment; }
  const showAlertNonPagabile = () => { return isAlertNonPagabileOpen ? <Alert color="info" > {causaleWarningNonPagabile} </Alert> : React.Fragment; }
  const showAlertPagato = () => { return isAlertPagatoOpen ? <Alert color="success" > {causalePagato} </Alert> : React.Fragment; }
  const showAlertNonPagato = () => { return isAlertNonPagatoOpen ? <Alert color="danger" > {causaleNonPagato} </Alert> : React.Fragment; }


  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="situazione" tag="section">
      <Alert color="info" >
          ATTENZIONE: &egrave; possibile consultare la situazione degli ultimi {Constants.ULTIMI_TRE_ANNI + 1} anni,  tranne i pagamenti relativi al ruolo.<br/>
          Per gli anni pregressi rivolgersi agli uffici <strong>ACI</strong> <em>(indirizzi e num. telefono presenti in <a target="_blank" href="https://servizi.regione.liguria.it/page/welcome/BOLLO_AUTO/Contatti?idinformazione=227">questa pagina Contatti </a>)</em>
      </Alert>
      {showAlertNonAnnuale()}
      {showAlertNonPagabile()}
      {showAlertPagato()}
      {showAlertNonPagato()}
      {showAlertInsufficiente()}
      <Row>
        <Col>
          <h3>Situazione Pagamenti</h3>
          <table className="table table-striped table-sm">
            <thead className="thead-light">
              <tr>
                <th className="align-middle text-center">Anno di imposta</th>
                <th className="align-middle text-center">Targa</th>
                {/* <th class="align-middle text-center">Valido fino a</th> */}
                <th className="align-middle text-center">Pagamento</th>
              </tr>
            </thead>
            <tbody>
              {situazionePagamenti.map((schedaPagamento) => (
                buildTableRow(schedaPagamento)
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
      {/* <Button
        className="btn btn-primary"
        size="xs"
        color="primary"
        icon={false}
        tag="button"
        onClick={_handleBack}
      > Chiudi
      </Button> */}
    </Container>
  )
}

export default SibaMostraSituazionePagamenti;